import React from 'react';
import { FormattedMessage } from 'react-intl';

export default [
    {
        trackingLabel: '1stdibs Gallery',
        href: 'https://www.1stdibs.com/info/gallery/',
        dataTn: 'footer-gallery',
        formattedMessage: (
            <FormattedMessage id="dbl.Footer.siteLinksGallery" defaultMessage="1stdibs Gallery" />
        ),
    },
    {
        formattedMessage: (
            <div>
                <span>269 11th Avenue, Lobby 6, 7th Floor</span>
                <br />
                <span>New York, NY 10001</span>
                <br />
                <span>(646) 779-0768</span>
            </div>
        ),
        dataTn: 'footer-gallery-address',
    },
];
